module.exports = __webpack_public_path__ + "static/kearney-logo-11ec366b11b3d21b7691e7f085357cda.png";